<template>
  <div
    :style="[styles.container, customStyle]"
    @click.stop=""
  >
    <img
      v-if="status !== 'loading' && showImage"
      :style="styles.statusImg"
      :src="getImgByStatus()"
    >
    <hy-text
      v-if="status !== 'loading'"
      size="xs"
      color="#999"
      :custom-style="{textAlign:'center'}"
    >
      {{ getMsg() }}
    </hy-text>
    <hy-button
      v-if="isShowButton"
      type="primary"
      :custom-style="styles.button"
      :title="getButtonText"
      @click="customClick"
    />
    <animation
      v-if="status === 'loading' && !supportNativeLoading"
      :playing="playing"
      :actions="loopActions"
      :style="{height:calcNum(30),width:calcNum(30), position: 'absolute'}"
    >
      <img
        :src="loadingImg"
        :style="{height:calcNum(30),width:calcNum(30),backgroundColor: 'transparent'}"
      >
    </animation>
    <NBRefreshSimpleLoadingView
      v-if="isNative"
      v-show="status === 'loading' && supportNativeLoading"
      ref="viewLoading"
      :anim-style="2.0"
      :style="{height:calcNum(30),width:calcNum(30), position: 'absolute'}"
      @layout="onLoadingLayout"
    />
  </div>
</template>

<script>
import StyleSheet from '@/components/basic/StyleSheet';
import Vue from 'vue';
import { isNative } from '@/utils/env';
import emptyImg from './img/com-status-empty.png';
import failImg from './img/com-status-fail.png';
import networkFailImg from './img/com-status-network-fail.png';
import loadingImg from './img/com-status-loading.png';

if (isNative) {
  Vue.registerElement('NBRefreshSimpleLoadingView', {
    component: {
      name: 'NBRefreshSimpleLoadingView',
      processEventData(event, nativeEventName) {
        console.log('nativeEventName:', nativeEventName);
        switch (nativeEventName) {
          default:
        }
        return event;
      },
    },
  });
}

/** 状态标志位 */
export const STATUS = {
  /** 数据加载中 */
  loading: 'loading',
  /** 页面为空 */
  empty: 'empty',
  /** 网络出错 */
  network: 'network',
  /** 加载成功 */
  success: 'success',
  /** 加载失败 */
  fail: 'fail',
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute', flexDirection: 'column', alignItems: 'center', display: 'flex', justifyContent: 'center', top: 0, bottom: 0, left: 0, right: 0, backgroundColor: '#FFFFFF',
  },
  statusImg: {
    width: 190, height: 135, marginBottom: 18, backgroundColor: 'transparent',
  },
  button: { width: 166, height: 38, marginTop: 12 },
});
export default {
  name: 'HyStatus',
  props: {
    customStyle: {
      type: Object,
      default: () => {},
    },
    showEmptyButton: {
      type: Boolean,
      default: () => false,
    },
    showFailButton: {
      type: Boolean,
      default: () => false,
    },
    status: {
      type: String,
      default: () => STATUS.empty,
    },
    text: {
      type: Object,
      default: () => ({
      }),
    },
    buttonTitle: {
      type: Object,
      default: () => ({
      }),
    },
    showImage: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      isNative,
      styles,
      basicStyle: {},
      defaultText: {
        empty: '内容正在快马加鞭生产中',
        fail: '内容加载失败，换个姿势刷新试试',
        network: '网络竟然崩溃了，换个姿势刷新试试',
        loading: '内容正在快马加鞭生产中',
      },
      defaultButtonText: {
        network: '刷新一下',
      },
      playing: false,
      loopActions: {
        transform: {
          rotate: {
            startValue: 0,
            toValue: 360,
            duration: 1030,
            repeatCount: -1,
            valueType: 'deg',
            origin: 'center',
          },
        },
      },
      loadingImg,
      supportNativeLoading: false,
    };
  },
  computed: {
    isShowButton() {
      if ((this.showEmptyButton && this.status === STATUS.empty)
          || this.status === STATUS.network
          || (this.showFailButton && this.status === STATUS.fail)
      ) {
        return true;
      }
      return false;
    },
    getButtonText() {
      const buttonTextMap = {
        ...this.defaultButtonText,
        ...this.buttonTitle,
      };

      return buttonTextMap ? buttonTextMap[this.status] : '';
    },
  },
  watch: {
    status: {
      immediate: true, // 这句重要
      handler(val) {
        if (val === 'loading') {
          this.playing = true;
        } else {
          this.playing = false;
        }
      },
    },
    playing() {
      this.handlePlaying();
    },
  },
  destroyed() {
    this.playing = false;
  },
  created() {
    this.tools.compareVersion('1.5.0')
      .then((res) => {
        if (res.code >= 0) {
          // 小于1.5.0不支持全局状态同步
          this.supportNativeLoading = true;
        }
      });
  },
  mounted() {
    Vue.Native.callUIFunction(this.$refs.viewLoading, 'startAnimation', null);
  },

  methods: {
    handlePlaying() {
      if (this.playing) {
        Vue.Native.callUIFunction(this.$refs.viewLoading, 'startAnimation', null);
        this.loadingTime = Date.now();
      } else {
        Vue.Native.callUIFunction(this.$refs.viewLoading, 'endAnimation', null);
      }
    },
    onLoadingLayout(evt) {
      this.handlePlaying();
      evt.stopPropagation();
    },
    getImgByStatus() {
      return {
        empty: emptyImg,
        fail: failImg,
        network: networkFailImg,
      }[this.status] || emptyImg;
    },
    getMsg() {
      const textMap = {
        ...this.defaultText,
        ...this.text,
      };
      return textMap ? textMap[this.status] : '';
    },
    customClick(evt) {
      if (this.status === STATUS.empty) {
        this.$emit('customClick', evt);
      } else {
        this.$emit('refreshClick', evt);
      }
    },
  },
};
</script>

<style scoped>

</style>
